// extracted by mini-css-extract-plugin
export default {"stickyArticleHeader":"N_cj","stickyArticleHeaderContainer":"N_ck","stickyArticleHeaderButton":"N_cl","text_left":"N_cm","progressContainer":"N_cn","progressBar":"N_cp"};